const recommendedWordingPath = '/recommended-wordings';
export default recommendedWordingPath;
